import { useMemo } from 'react'

import { useTemplateContext } from '../../context/templateContext'
import { useLazyLayerMetaModel } from '../../context/useLazyLayerMetaModel'
import type { ConfigurationTemplateFunctionValue } from '../../types/templateModel'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { getFunctionTypeInformation } from './expressionType'

export const useFunctionLiteralExpressionInformation = (
  value: ConfigurationTemplateFunctionValue,
) => {
  const { templateVersion } = useTemplateContext()
  const metaModel = useLazyLayerMetaModel(templateVersion?.layer?.layerId)
  const { applicationEnumDefinitions } = useApplicationViewOperationsContext()

  return useMemo(
    () =>
      getFunctionTypeInformation({
        value,
        configuredEnums: applicationEnumDefinitions,
        metaModel,
      }),
    [applicationEnumDefinitions, value, metaModel],
  )
}
